import React, { Component } from 'react';
import { connect } from 'react-redux';
import { Switch, Route } from 'react-router-dom';
import { Tabs, Tab } from 'react-bootstrap';
import {
	fetchIndividualConsultation, updateIndividualConsultation,
	markAsPaid, refundIndividualConsultation, sendInvoice,
	INDIVIDUAL_CONSULTATION_MARK_AS_PAID_REQUEST, INDIVIDUAL_CONSULTATION_MARK_AS_PAID_SUCCESS, INDIVIDUAL_CONSULTATION_MARK_AS_PAID_FAILURE
} from './actions';
import {
	markAsCancelled,
	retryInstalment,
	PAYMENT_HISTORY_MARK_AS_CANCELLED_REQUEST, PAYMENT_HISTORY_MARK_AS_CANCELLED_SUCCESS, PAYMENT_HISTORY_MARK_AS_CANCELLED_FAILURE,
	PAYMENT_HISTORY_RETRY_INSTALMENT_REQUEST, PAYMENT_HISTORY_RETRY_INSTALMENT_SUCCESS, PAYMENT_HISTORY_RETRY_INSTALMENT_FAILURE
} from '../paymentHistory/actions';
import {
	markAsPaidInstalment,
	INSTALMENT_PAYMENT_MARK_AS_PAID_REQUEST, INSTALMENT_PAYMENT_MARK_AS_PAID_SUCCESS, INSTALMENT_PAYMENT_MARK_AS_PAID_FAILURE
} from '../instalmentPayments/actions';
import MarkAsPaidInstalmentDialog from '../paymentHistory/MarkAsPaidInstalmentDialog';
import IndividualConsultationSettingsForm from './SettingsForm';
import MarkAsPaidDialog from '../paymentHistory/MarkAsPaidDialog';
import IndividualConsultationDocumentsList from '../individualConsultationDocuments/index';
import IndividualConsultationDocumentDetails from '../individualConsultationDocuments/Details';
import IndividualConsultationFormsList from '../individualConsultationForms/index';
import MarkAsCancelledDialog from '../paymentHistory/MarkAsCancelledDialog';
import authUtils from '../../auth/utils';
import { withTranslation } from 'react-i18next';

class Details extends Component {
	constructor(props) {
		super(props);
		this.handleIndividualConsultationSettingsSubmit = this.handleIndividualConsultationSettingsSubmit.bind(this);
		this.handleRefundIndividualConsultation = this.handleRefundIndividualConsultation.bind(this);
		this.handleMarkAsPaidDialogConfirm = this.handleMarkAsPaidDialogConfirm.bind(this);
		this.showMarkAsPaidDialog = this.showMarkAsPaidDialog.bind(this);
		this.hideMarkAsPaidDialog = this.hideMarkAsPaidDialog.bind(this);
		this.handleTabSelect = this.handleTabSelect.bind(this);
		this.handleSendInvoice = this.handleSendInvoice.bind(this);
		this.handleMarkAsCancelledDialogConfirm = this.handleMarkAsCancelledDialogConfirm.bind(this);
		this.handleRetryInstalment = this.handleRetryInstalment.bind(this);
		this.showMarkAsCancelledDialog = this.showMarkAsCancelledDialog.bind(this);
		this.hideMarkAsCancelledDialog = this.hideMarkAsCancelledDialog.bind(this);
		this.reloadIndividualConsultation = this.reloadIndividualConsultation.bind(this);
		this.showMarkAsPaidInstalmentDialog = this.showMarkAsPaidInstalmentDialog.bind(this);
		this.hideMarkAsPaidInstalmentDialog = this.hideMarkAsPaidInstalmentDialog.bind(this);
		this.handleMarkAsPaidInstalmentDialogConfirm = this.handleMarkAsPaidInstalmentDialogConfirm.bind(this);

		this.state = {
			showMarkAsPaidDialog: false,
			showMarkAsCancelledDialog: false,
			showMarkAsPaidInstalmentDialog: false
		};
	}

	componentDidMount() {
		this.reloadIndividualConsultation();
	}

	reloadIndividualConsultation() {
		const { match, fetchIndividualConsultation } = this.props;
		const individualConsultationId = match.params.id;

		if (individualConsultationId) {
			fetchIndividualConsultation(individualConsultationId);
		}
	}

	handleIndividualConsultationSettingsSubmit(values) {
		const { individualConsultation, createIndividualConsultation, updateIndividualConsultation, history } = this.props;

		if (individualConsultation) {
			updateIndividualConsultation(individualConsultation.id, values);
		}
	}

	handleRefundIndividualConsultation() {
		const { individualConsultation, refundIndividualConsultation } = this.props;
		if (individualConsultation) {
			refundIndividualConsultation(individualConsultation.id);
		}
	}
	handleMarkAsPaidDialogConfirm(values) {
		const { individualConsultation, markAsPaid } = this.props;
		if (individualConsultation) {
			markAsPaid(individualConsultation.id, values, this.hideMarkAsPaidDialog);
		}
	}

	handleSendInvoice() {
		const { individualConsultation, sendInvoice } = this.props;
		if (individualConsultation) {
			sendInvoice(individualConsultation.id);
		}
	}

	showMarkAsPaidDialog() {
		this.setState({
			showMarkAsPaidDialog: true
		});
	}

	hideMarkAsPaidDialog() {
		this.setState({
			showMarkAsPaidDialog: false
		});
	}

	handleTabSelect(key) {
		const paymentId = this.props.individualConsultation.id;
		const parentId = this.props.parentId;
		this.props.history.replace(`/individualConsultations/${paymentId}/${parentId}/${key}`);
	}

	handleMarkAsCancelledDialogConfirm(values) {
		const { individualConsultation, markAsCancelled } = this.props;
		if (individualConsultation) {
			const onSuccessEvent = () => {
				this.hideMarkAsCancelledDialog();
				this.reloadIndividualConsultation();
			}
			markAsCancelled(individualConsultation.id, values, onSuccessEvent);
		}
	}

	showMarkAsCancelledDialog() {
		this.setState({
			showMarkAsCancelledDialog: true
		});
	}

	hideMarkAsCancelledDialog() {
		this.setState({
			showMarkAsCancelledDialog: false
		});
	}

	handleRetryInstalment(instalmentPaymentId) {
		const { individualConsultation, retryInstalment } = this.props;
		if (individualConsultation) {
			retryInstalment(individualConsultation.id, instalmentPaymentId, this.reloadIndividualConsultation);
		}
	}
	handleMarkAsPaidInstalmentDialogConfirm(values) {
		const { markAsPaidInstalment } = this.props;
		var instalment = this.state.instalment;
		if (instalment) {
			markAsPaidInstalment(instalment.id, values,
				() => {
					this.hideMarkAsPaidInstalmentDialog();
					this.reloadIndividualConsultation();
				});
		}
	}

	showMarkAsPaidInstalmentDialog(instalment) {
		this.setState({
			showMarkAsPaidInstalmentDialog: true,
			instalment
		});
	}

	hideMarkAsPaidInstalmentDialog() {
		this.setState({
			showMarkAsPaidInstalmentDialog: false
		});
	}

	render() {
		const { individualConsultation, canMarkAsPaid, canCancel, canViewDocuments, canRefund, isReadonly, match, parentId,
			canUploadInvoice, canSendInvoice, showPaymentOptions, canRetryInstalment, t } = this.props;

		if (individualConsultation) {
			const invoiceFile = individualConsultation.invoice && {
				filename: individualConsultation.invoice.friendlyFilename,
				url: individualConsultation.invoice.url
			};

			const individualConsultationDetails = <div>
				<MarkAsPaidDialog show={this.state.showMarkAsPaidDialog}
					showPaymentOptions={showPaymentOptions}
					block={INDIVIDUAL_CONSULTATION_MARK_AS_PAID_REQUEST}
					unblock={[INDIVIDUAL_CONSULTATION_MARK_AS_PAID_SUCCESS, INDIVIDUAL_CONSULTATION_MARK_AS_PAID_FAILURE]}
					onConfirm={this.handleMarkAsPaidDialogConfirm}
					onCancel={this.hideMarkAsPaidDialog} />
				<MarkAsCancelledDialog show={this.state.showMarkAsCancelledDialog}
					block={PAYMENT_HISTORY_MARK_AS_CANCELLED_REQUEST}
					unblock={[PAYMENT_HISTORY_MARK_AS_CANCELLED_SUCCESS, PAYMENT_HISTORY_MARK_AS_CANCELLED_FAILURE]}
					onConfirm={this.handleMarkAsCancelledDialogConfirm}
					onCancel={this.hideMarkAsCancelledDialog}
					outstandingTotal={individualConsultation.outstandingTotal}
					paymentMethod={individualConsultation.paymentMethod && individualConsultation.paymentMethod.name}
					showWarning={individualConsultation.isInstalmentPayment && (individualConsultation.status.id === 2 || individualConsultation.status.id === 6)}
				/>
				<MarkAsPaidInstalmentDialog show={this.state.showMarkAsPaidInstalmentDialog}
					block={INSTALMENT_PAYMENT_MARK_AS_PAID_REQUEST}
					unblock={[INSTALMENT_PAYMENT_MARK_AS_PAID_SUCCESS, INSTALMENT_PAYMENT_MARK_AS_PAID_FAILURE]}
					onConfirm={this.handleMarkAsPaidInstalmentDialogConfirm}
					onCancel={this.hideMarkAsPaidInstalmentDialog} />
				<IndividualConsultationSettingsForm
					isReadonly={isReadonly}
					onSubmit={this.handleIndividualConsultationSettingsSubmit}
					initialValues={individualConsultation}
					invoiceFile={invoiceFile}
					canMarkAsPaid={canMarkAsPaid}
					canCancel={canCancel}
					markAsPaid={this.showMarkAsPaidDialog}
					markAsCancelled={this.showMarkAsCancelledDialog}
					canRefund={canRefund}
					refundIndividualConsultation={this.handleRefundIndividualConsultation}
					canUploadInvoice={canUploadInvoice}
					canSendInvoice={canSendInvoice}
					sendInvoice={this.handleSendInvoice}
					canRetryInstalment={canRetryInstalment}
					retryInstalment={this.handleRetryInstalment}
					onRefresh={this.reloadIndividualConsultation}
					markInstalmentAsPaid={this.showMarkAsPaidInstalmentDialog}
					canMarkInstalmentAsPaid={this.props.canMarkInstalmentAsPaid}
				/>
			</div>;

			const selectedTab = match.params.tab || 'details';
			return (<div>
				<Tabs defaultActiveKey={selectedTab} onSelect={this.handleTabSelect}>
					<Tab eventKey='details' title={t('IndividualConsultation_Tab_Details')}>
						{individualConsultationDetails}
					</Tab>
					{canViewDocuments && <Tab eventKey='individualConsultationDocuments' title={t('IndividualConsultation_Tab_Documents')} >
						<Switch>
							<Route path={`${match.url}`} exact render={props => <IndividualConsultationDocumentsList paymentId={individualConsultation.id} parentId={parentId} />} />
							<Route path={`${match.url}/newIndividualProgram`} render={props => <IndividualConsultationDocumentDetails paymentId={individualConsultation.id} parentId={parentId} documentType={2} {...props} />} />
							<Route path={`${match.url}/newAnalysis`} render={props => <IndividualConsultationDocumentDetails paymentId={individualConsultation.id} parentId={parentId} documentType={3} {...props} />} />
						</Switch>
					</Tab>}
					{canViewDocuments && <Tab eventKey='individualConsultationForms' title={t('IndividualConsultation_Tab_Forms')} >
						<Switch>
							<Route path={`${match.url}`} exact render={props => <IndividualConsultationFormsList paymentId={individualConsultation.id} />} />
						</Switch>
					</Tab>}
				</Tabs>
			</div>);
		}

		return null;
	}
}

const mapStateToProps = (state, ownProps) => {
	const individualConsultationId = ownProps.match.params.id;
	const parentId = ownProps.match.params.parentId;

	const {
		entities: { individualConsultations },
		auth: { currentUser }
	} = state;

	const individualConsultation = individualConsultations[individualConsultationId];
	let canMarkAsPaid, canCancel, canViewDocuments, canEditDocuments, canRefund, canUploadInvoice, canSendInvoice, showPaymentOptions;
	if (individualConsultation) {
		canMarkAsPaid = individualConsultation.canMarkAsPaid && authUtils.hasPermission(currentUser, 'MarkAsPaid');
		canCancel = individualConsultation.canCancel && authUtils.hasPermission(currentUser, 'MarkAsPaid');
		canRefund = individualConsultation.canRefund && authUtils.hasPermission(currentUser, 'MarkAsPaid');
		const documentsPermission = authUtils.getPermission(currentUser, 'IndividualConsultationDocuments');
		canViewDocuments = individualConsultation.canAttachDocuments && documentsPermission;
		canEditDocuments = individualConsultation.canAttachDocuments && documentsPermission && !documentsPermission.isReadOnly;
		canUploadInvoice = authUtils.hasPermission(currentUser, 'UploadInvoice');
		canSendInvoice = authUtils.hasPermission(currentUser, 'MarkAsPaid') && individualConsultation.status.id === 2;
		showPaymentOptions = individualConsultation.showPaymentOptions;
	}

	return {
		individualConsultation,
		canMarkAsPaid,
		canCancel,
		canViewDocuments,
		canEditDocuments,
		canRefund,
		canRetryInstalment: authUtils.hasPermission(currentUser, 'MarkAsPaid'),
		isReadonly: authUtils.hasReadOnlyPermission(currentUser, 'IndividualConsultations'),
		parentId,
		canUploadInvoice,
		canSendInvoice,
		showPaymentOptions,
		canMarkInstalmentAsPaid: authUtils.hasPermission(currentUser, 'MarkInstalmentAsPaid')
	};
};

export default connect(mapStateToProps, {
	fetchIndividualConsultation,
	updateIndividualConsultation,
	markAsPaid,
	markAsCancelled,
	refundIndividualConsultation,
	sendInvoice,
	retryInstalment,
	markAsPaidInstalment
})(withTranslation()(Details));